export const withCurrentCopyrightYear = (text: string): string => {
  return text.replace(/©\s*(\d{4}\s+)?/, `© ${new Date().getFullYear()} `)
}
